import { translations } from './translations.js';

class I18n {
  constructor() {
    this.currentLanguage = localStorage.getItem('myclass-language') || 'en';
    this.translations = translations;
    this.listeners = [];
  }

  // Get translation for a key
  t(key, params = {}) {
    const keys = key.split('.');
    let value = this.translations[this.currentLanguage];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
    }

    if (typeof value === 'string') {
      // Replace parameters in the translation
      return value.replace(/\{(\w+)\}/g, (match, param) => {
        return params[param] !== undefined ? params[param] : match;
      });
    }

    return value || key;
  }

  // Get current language
  getCurrentLanguage() {
    return this.currentLanguage;
  }

  // Set language
  setLanguage(language) {
    if (this.translations[language]) {
      this.currentLanguage = language;
      localStorage.setItem('myclass-language', language);
      this.notifyListeners();
    } else {
      console.warn(`Language not supported: ${language}`);
    }
  }

  // Subscribe to language changes
  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  // Notify all listeners
  notifyListeners() {
    this.listeners.forEach(listener => listener(this.currentLanguage));
  }

  // Get available languages
  getAvailableLanguages() {
    return Object.keys(this.translations);
  }
}

export function createI18n() {
  return new I18n();
}
